import { render, staticRenderFns } from "./WalletSale.vue?vue&type=template&id=36e27841&scoped=true"
import script from "./WalletSale.vue?vue&type=script&lang=js"
export * from "./WalletSale.vue?vue&type=script&lang=js"
import style0 from "./WalletSale.vue?vue&type=style&index=0&id=36e27841&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e27841",
  null
  
)

export default component.exports